import { Form, Formik } from "formik";
import { observable } from "mobx";
import { inject, observer } from "mobx-react";
import { fromPromise, IPromiseBasedObservable } from "mobx-utils";
import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import { RouteComponentProps, withRouter } from "react-router";
import { compose } from "recompose";
import * as yup from "yup";

import { PrimaryBlueButton, SecondaryButton } from "nvent-web/components/Button";
import { TextField } from "nvent-web/components/form/TextField";

import { LoginFlow } from "../../stores/LoginFlow";
import style from "./ForgotPasswordForm.module.scss";

export interface ForgotPasswordFormInnerProps extends RouteComponentProps<{}> {
  login: LoginFlow;
}

interface Values {
  email: string;
}

const validationSchema = yup.object<Values>({
  email: yup
    .string()
    .email()
    .required(),
});

export class ForgotPasswordFormInner extends Component<ForgotPasswordFormInnerProps> {
  @observable
  submitPromise?: IPromiseBasedObservable<void>;

  render() {
    const { login } = this.props;
    const initialValues: Values = {
      email: login.email,
    };
    const isSubmitting = this.submitPromise && this.submitPromise.state === "pending";

    return (
      <Formik initialValues={initialValues} onSubmit={this.submit} validationSchema={validationSchema}>
        {() => (
          <Form noValidate={true}>
            <TextField type="email" name="email" label={<FormattedMessage id="form.email" />} />

            <div className={style.row}>
              <div className={style.cancel}>
                <SecondaryButton size="large" onClick={this.cancel} className={style.cancelButton}>
                  <FormattedMessage id="actions.cancel" />
                </SecondaryButton>
              </div>

              <div className={style.submit}>
                <PrimaryBlueButton
                  type="submit"
                  size="large"
                  disabled={isSubmitting}
                  loading={isSubmitting}
                  className={style.submitButton}
                >
                  <FormattedMessage id="actions.send" />
                </PrimaryBlueButton>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    );
  }

  private submit = ({ email }: Values) => {
    this.submitPromise = fromPromise(this.props.login.startPasswordReset(email));
  };

  private cancel = () => {
    this.props.history.goBack();
  };
}

export const ForgotPasswordForm = compose<ForgotPasswordFormInnerProps, {}>(
  inject("login"),
  withRouter,
  observer
)(ForgotPasswordFormInner);

export default ForgotPasswordForm;
